if (!customElements.get('marquee-text')) {
  class MarqueeText extends HTMLElement {
    constructor() {
      super();
    }

    animationLoop() {
      if (this.enablePause && this.stopped)
        return window.requestAnimationFrame(() => {
          this.animationLoop();
        });

      const firstListItem = this.firstElementChild;
      let rightSideOfFirstItem = firstListItem.getBoundingClientRect().right;

      if (rightSideOfFirstItem <= this.containerLeft) {
        this.currentLeft = -this.speed;
        this.appendChild(firstListItem);
      }

      this.style.transform = `translate3d(${this.currentLeft}px, 0, 0)`;
      this.currentLeft -= this.speed;

      window.requestAnimationFrame(() => {
        this.animationLoop();
      });
    }

    connectedCallback() {
      const options = {
        root: null, // Uses the viewport as the root
        rootMargin: '100px',
        threshold: 0.1, // Triggers when 10% of the target is visible
      };

      const observer = new IntersectionObserver((entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(entries[0].target);

        this.containerLeft = this.parentElement.getBoundingClientRect().left;
        this.currentLeft = 0;
        this.stopped = false;
        this.speed = Number(this.dataset.speed) || 1;
        this.enablePause = this.hasAttribute('data-pause-on-hover');

        this.addEventListener('mouseenter', () => (this.stopped = true));
        this.addEventListener('mouseleave', () => (this.stopped = false));

        this.animationLoop();
      }, options);

      observer.observe(this.closest('.shopify-section'));
    }
  }

  customElements.define('marquee-text', MarqueeText);
}
